"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _button = require("@jsluna/button");

var _modal = require("@jsluna/modal");

var _typography = require("@jsluna/typography");

var _grid = require("@jsluna/grid");

var _form = require("@jsluna/form");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AddressListModal = function AddressListModal(props) {
  var isOpen = props.isOpen,
      headerText = props.headerText,
      buttonText = props.buttonText,
      addressList = props.addressList,
      handleClose = props.handleClose,
      errorValidation = props.errorValidation,
      _onChange = props.onChange,
      onSelectAddressBtn = props.onSelectAddressBtn;
  var options = addressList && addressList.map(function (address, index) {
    return {
      label: address,
      value: index
    };
  });
  return /*#__PURE__*/_react.default.createElement(_modal.Modal, {
    className: "ln-u-hard",
    open: isOpen,
    handleClose: handleClose,
    headingId: "address-list-modal"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-u-margin-top ln-u-margin-bottom*2"
  }, /*#__PURE__*/_react.default.createElement(_typography.ButtonText, null, headerText))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, null, /*#__PURE__*/_react.default.createElement(_form.SelectField, {
    className: "ln-u-margin-bottom*3",
    name: "addresList",
    placeholder: "Select address",
    options: options,
    error: errorValidation,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      sm: '1/4'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    fullWidth: true,
    onClick: function onClick() {
      return onSelectAddressBtn();
    }
  }, buttonText))));
};

AddressListModal.propTypes = {
  isOpen: _propTypes.PropTypes.bool.isRequired,
  headerText: _propTypes.PropTypes.string.isRequired,
  buttonText: _propTypes.PropTypes.string.isRequired,
  addressList: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.string).isRequired,
  handleClose: _propTypes.PropTypes.func.isRequired,
  errorValidation: _propTypes.PropTypes.string.isRequired,
  onChange: _propTypes.PropTypes.func.isRequired,
  onSelectAddressBtn: _propTypes.PropTypes.func.isRequired
};
var _default = AddressListModal;
exports.default = _default;